import { render, staticRenderFns } from "./anchor-modal.vue?vue&type=template&id=34c1c604&"
import script from "./anchor-modal.vue?vue&type=script&lang=js&"
export * from "./anchor-modal.vue?vue&type=script&lang=js&"
import style0 from "./anchor-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports